/**
 * Signing a till out when nobody has touched it - only if the shop wants that.
 *
 * Settings -> At the till decides how long, and "Never" is the default: a till
 * behind the counter belongs to the shop, and signing it out between customers
 * only makes the next one wait.
 *
 * Never while the connection is down, whatever the setting. Signing in needs
 * the server, so an idle timeout during a power cut would lock the shop out of
 * its own till until the internet came back.
 */
import { useEffect } from 'react';
import { useAuth } from './auth.js';
import { useSettings } from './settings.js';

export function IdleSignOut() {
  const { user, signOut } = useAuth();
  const minutes = useSettings().settings.idleSignOutMinutes ?? 0;

  useEffect(() => {
    if (!user || !(minutes > 0)) return;
    const ms = minutes * 60_000;
    const signOutIfOnline = () => {
      if (navigator.onLine) signOut();
      else timer = window.setTimeout(signOutIfOnline, ms);
    };
    let timer = window.setTimeout(signOutIfOnline, ms);
    const reset = () => {
      clearTimeout(timer);
      timer = window.setTimeout(signOutIfOnline, ms);
    };
    const events = ['pointerdown', 'keydown', 'touchstart'] as const;
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    return () => {
      clearTimeout(timer);
      events.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [user, signOut, minutes]);

  return null;
}
